import { render, staticRenderFns } from "./CargoCard.vue?vue&type=template&id=14952387&scoped=true"
import script from "./CargoCard.vue?vue&type=script&lang=js"
export * from "./CargoCard.vue?vue&type=script&lang=js"
import style0 from "./CargoCard.vue?vue&type=style&index=0&id=14952387&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14952387",
  null
  
)

export default component.exports